import React, { useCallback, useMemo } from 'react';
import { Checkbox } from 'tea-component';
import { GroupChildrenItemType, GroupOptionsItemType } from './type';

export default (props: {
  data: GroupOptionsItemType;
  selectOptions: Array<string>;
  getChange: (value: any) => void;
  searchValue: string;
  // disabled?: boolean;
  optionItemRender?: (
    element: string | JSX.Element,
    value?: string,
  ) => string | JSX.Element;
  optionItemFormatter?: (
    element: string | JSX.Element,
    value: string,
  ) => string | JSX.Element;
}) => {
  const {
    data,
    selectOptions,
    getChange = (value: any) => {},
    searchValue,
    // disabled = false,
    optionItemRender = (element: any) => element,
    optionItemFormatter = (element: any) => element,
  } = props;

  const groupList = useMemo(() => {
    let group: Array<string> = [];
    data.children?.forEach((item: GroupChildrenItemType) => {
      group.push(item.value);
    });
    return group;
  }, [data]);

  // 判断组全选或半选 isCheckAll true时判断是否全选 false判断半选情况
  const getGroupSelected = useCallback(
    (isCheckAll: boolean) => {
      const isAll = groupList.every((key: string) =>
        selectOptions.includes(key),
      );
      if (isCheckAll) {
        return isAll;
      }
      if (isAll) {
        return false;
      }
      return groupList.some((key: string) => selectOptions.includes(key));
    },
    [searchValue, selectOptions],
  );

  return (
    <>
      <Checkbox
        className="db-group-checkbox"
        display="block"
        indeterminate={getGroupSelected(false)}
        value={getGroupSelected(true)}
        onChange={(value) => {
          // 组内全选、反选 判断value 是 true 添加， 否则删除
          if (value) {
            const newList = Array.from(
              new Set([...selectOptions, ...groupList]),
            );
            getChange(newList);
          } else {
            const newList = selectOptions.filter((item: string) => {
              return !groupList.includes(item);
            });
            getChange(newList);
          }
        }}
      >
        {data.groupValue}
      </Checkbox>
      <Checkbox.Group
        className="db-group-checkbox-child-wrapper"
        value={selectOptions}
        onChange={(value) => {
          getChange(value);
        }}
      >
        {data.children?.map(
          (item: GroupChildrenItemType, value: number | string) => {
            return (
              <Checkbox
                key={value}
                className="db-group-checkbox"
                name={item.value}
              >
                {optionItemRender(
                  optionItemFormatter(item.text, searchValue),
                  item.value,
                )}
              </Checkbox>
            );
          },
        )}
      </Checkbox.Group>
    </>
  );
};
